import React from 'react';
import { Box } from '@mui/material';

import { HistoryGrid } from './HistoryGrid';

export function History() {
  return (
    <Box sx={{ flexGrow: 1, height: 'inherit' }}>
      <HistoryGrid />
    </Box>
  );
}
